import React, {useEffect, useRef, useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import CardForm from "../../components/form/CardForm";
import {useHistory, useParams} from "react-router-dom";
import {Actions} from "../../../client/Actions";
import { useFontFillAllConfig } from "./FontFillAllFormConfig";
import {MachineHeader} from "../format/MachineHeader";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import { useModels } from "../../helpers/models";
import {Alert, Badge, Col, Row} from "react-bootstrap";
import {MiniNavigation} from "../../components/nav/MiniNavigation";
import ConfirmButton from "../../components/button/ConfirmButton";
import {Summary} from "../../components/summary/Summary";
import {InventoryDetails} from "./InventoryDetails";
import CustomCard from "../../components/CustomCard";
import { useTranslation } from 'react-i18next';

const FontInventoryPage = (props) => {
    let {machineId} = useParams();
    let {inventoryId} = useParams();
    const history = useHistory();

    const { t } = useTranslation();
    const models = useModels();
    const fontFillAllConfig = useFontFillAllConfig();

    const [loader, setLoader] = useState(false);

    const [inventory, setInventory] = useState();
    const [machine, setMachine] = useState();
    const [fonts, setFonts] = useState();

    const [minimalQuantityFields, setMinimalQuantityFields] = useState();

    const [actualQuantityFields, setActualQuantityFields] = useState();
    const [actualQuantity, setActualQuantity] = useState({});
    const [initialActualQuantity, setInitialActualQuantity] = useState();
    const [fillAllActualQuantity, setFillAllActualQuantity] = useState();
    const [dataSaved, setDataSaved] = useState(true);

    const [summary, setSummary] = useState();

    const detailsRef = useRef(null);
    const actualRef = useRef(null);
    const minimalRef = useRef(null);

    const sections = [
        {ref: detailsRef, name: "details", menu: t("common.details")},
        {ref: actualRef, name: "actualRef", menu: t("common.current_states")},
        {ref: minimalRef, name: "blister", menu: t("common.minimal_states")}
    ];


    function loadData() {
        setLoader(true)
        Actions.get("machine/" + machineId, machineLoaded)
        Actions.get("font/" + machineId, setFonts)
        Actions.get("fontInventory/" + inventoryId, setInventory)
    }


    function machineLoaded(data) {
        setMachine(data)
        setLoader(false)
    }

    function fontsLoaded() {
        if (fonts && inventory) {
            const minimal = fonts.map((value, i) => {
                return {
                    name: `${value.id}`,
                    label: value.name,
                    defaultValue: value.minimalQuantity,
                    type: "number",
                    column: i + 1 > columns ? (i % columns) + 1 : i + 1
                }
            })
            const actual = fonts.map((font, i) => {
                return {
                    name: `${font.id}`,
                    label: font.name,
                    defaultValue: inventory.fontInventoryData.find(d => d.font.id === font.id)?.quantity,
                    type: "number",
                    column: i + 1 > columns ? (i % columns) + 1 : i + 1
                }
            })

            setMinimalQuantityFields(minimal)
            setActualQuantityFields(actual)
        }
    }


    function onSaved() {
        setInitialActualQuantity(actualQuantity)
        setDataSaved(true)
        loadData()
    }

    function save() {
        const dtos = Object.keys(actualQuantity).map(k => {
            return {
                fontId: parseInt(k),
                quantity: actualQuantity[k]
            }
        })


        setLoader(true)
        Actions.post("fontInventory/" + inventoryId + "/data", dtos, onSaved)
    }

    function onFinish() {
        setLoader(true)
        Actions.post("fontInventory/deactivate/" + machineId, {
            inventoryEndComment: summary
        }, onSaved)
    }


    function actualQuantityChanged() {
        if (actualQuantity && Object.keys(actualQuantity).length > 0) {
            if (!initialActualQuantity) {
                setInitialActualQuantity(actualQuantity)
            }

            const tmp = fonts.filter(f => parseInt(actualQuantity[f.id]) < f.minimalQuantity)
                .map(f => t("forms.font_below_minimal", {fontName: f.name, currentState: actualQuantity[f.id], minimalState: f.minimalQuantity}))
                .join(";")
            setSummary(tmp)

            if (initialActualQuantity) {
                const anyDifference = Object.keys(initialActualQuantity)
                    .some(k => parseInt(initialActualQuantity[k]) !== parseInt(actualQuantity[k]))

                setDataSaved(!anyDifference)
            }
        }
    }

    const columns = 6


    useEffect(loadData, [machineId])
    useEffect(fontsLoaded, [fonts, inventory])
    useEffect(actualQuantityChanged, [actualQuantity])

    function getTitle() {
        return <>
            {t("menu.font_inventory")}
        </>;
    }

    return (
        <>
            <Loader loader={loader}/>

            <CustomContainer
                title={getTitle()}
                parent={
                    <>
                        <LinkIconButton
                            model={models.font}
                        />
                        <LinkIconButton
                            model={models.font.inventory}
                        />
                    </>
                }
                subtitle={
                    <>
                        {inventory?.active && <Badge className={"badge-primary-outline mr-5"}>{t("status.in_progress")}</Badge>}
                        {inventory && !inventory.active &&
                            <Badge className={"outline-secondary font-max mr-2"}>{t("status.done")}</Badge>}
                        {machine &&
                            <MachineHeader
                                card={false}
                                machine={machine}
                                packingLineName={machine.packingLineName}
                            />
                        }
                    </>
                }>

                <Col>
                    <MiniNavigation
                        defaultSection={detailsRef}
                        sections={sections}
                        actionsRight={inventory && inventory.active &&
                            <>
                                {dataSaved &&
                                    <ConfirmButton
                                        variant={"outline-primary"}
                                        modalSize={"lg"}
                                        confirmTitle={t("forms.finish_inventory")}
                                        onConfirm={onFinish}
                                        modalChildren={<div><Summary
                                            width={12}
                                            shadow={false}
                                            summary={summary}/>
                                            <CustomCard
                                                width={12}
                                                shadow={false}
                                                withoutHeader={true}><strong>{t("confirmations.are_you_sure_finish_inventory")}
                                                </strong>
                                            </CustomCard>

                                        </div>
                                        }
                                    >
                                        {t("status.finish")}
                                    </ConfirmButton>
                                }
                                {!dataSaved &&
                                    <Alert variant={"warning"}>{t("forms.data_not_saved")}</Alert>}
                            </>
                        }/>
                    <Row ref={detailsRef}>
                        <InventoryDetails inventory={inventory} loader={setLoader}/>
                        <Summary withInfo={true} summary={inventory?.inventoryEndComment || summary}/>
                    </Row>
                    {minimalQuantityFields && actualQuantityFields &&
                        <>
                            {inventory?.active &&
                                <Row>
                                    <CardForm
                                        withoutHeader={true}
                                        setLoader={setLoader}

                                        fields={fontFillAllConfig}
                                        width={3}
                                        withoutCancel={true}
                                        saveButton={t("common.fill")}
                                        disableLoader={true}
                                        customSave={(data) => {
                                            const tmp = {}
                                            actualQuantityFields.forEach(f => tmp[f.name] = data.value)
                                            setFillAllActualQuantity(tmp)
                                        }}
                                    />
                                </Row>
                            }
                            <Row ref={actualRef}>
                                <CardForm
                                    title={t("common.current_states")}
                                    setLoader={setLoader}
                                    replaceFormData={fillAllActualQuantity}
                                    fields={{
                                        config: {columns: columns},
                                        fields: actualQuantityFields
                                    }}
                                    width={12}
                                    readOnly={!inventory?.active}
                                    onRemoveField={() => {
                                    }}
                                    formDataChanged={(data) => setActualQuantity(data)}
                                    customSave={save}
                                />
                            </Row>
                            <Row ref={minimalRef}>
                                <CardForm
                                    title={t("common.minimal_states")}
                                    setLoader={setLoader}
                                    fields={{
                                        config: {columns: columns},
                                        fields: minimalQuantityFields
                                    }}
                                    width={12}
                                    readOnly={true}
                                    onRemoveField={() => {
                                    }}
                                    customSave={save}
                                />
                            </Row>
                        </>
                    }
                </Col>
            </CustomContainer>
        </>
    );
};

export default FontInventoryPage;
